import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class GetAllUsersRequest extends Request {
    constructor() {
        super({
            req: RequestTypes.GET_ALL_UI_PARAMS,
            req_id: 0,
        });
    }
}

export default GetAllUsersRequest;